// Translation files for Career Step
// Languages: English, Zulu (isiZulu), Xhosa (isiXhosa), Afrikaans

export const translations = {
  en: {
    // Header & Navigation
    "nav.about": "About",
    "nav.login": "Log In",
    "nav.getStarted": "Get 30 Days for R25",
    "nav.dashboard": "Dashboard",
    "nav.logout": "Log Out",
    
    // Landing Page
    "landing.badge": "Built for South African Job Seekers",
    "landing.title": "Land Your Dream Job",
    "landing.titleHighlight": "with an Honest CV",
    "landing.subtitle": "Create professional, ATS-friendly CVs that showcase your real experience. No fake qualifications. No invented skills. Just you, presented professionally.",
    "landing.cta": "Start Building Your CV",
    "landing.pricing.bestValue": "BEST VALUE",
    "landing.pricing.title": "30 Days Full Access",
    "landing.pricing.price": "R25",
    "landing.pricing.period": "once-off",
    "landing.pricing.features.cvs": "Up to 6 professional CVs",
    "landing.pricing.features.ai": "AI-powered CV enhancement",
    "landing.pricing.features.interview": "AI Mock Interview practice",
    "landing.pricing.features.matching": "Job matching & ATS scoring",
    "landing.pricing.features.pdf": "Unlimited PDF downloads",
    "landing.pricing.cta": "Get Started Now",
    "landing.pricing.note": "No auto-renewal • Your data stays safe forever",
    "landing.promise": "Our Promise:",
    "landing.promiseText": "We never invent experience or qualifications. Your CV contains only what you provide.",
    
    // Dashboard
    "dashboard.welcome": "Welcome back",
    "dashboard.myCvs": "My CVs",
    "dashboard.createCv": "Create New CV",
    "dashboard.noCvs": "You haven't created any CVs yet",
    "dashboard.noCvsSubtext": "Create your first professional CV in minutes",
    "dashboard.stats.cvs": "CVs Created",
    "dashboard.stats.downloads": "Downloads",
    "dashboard.stats.atsScore": "Avg ATS Score",
    "dashboard.stats.applications": "Applications",
    "dashboard.tools": "Career Tools",
    "dashboard.tools.coverLetter": "Cover Letter",
    "dashboard.tools.coverLetterDesc": "Create tailored cover letters",
    "dashboard.tools.interview": "Interview Prep",
    "dashboard.tools.interviewDesc": "AI-powered mock interviews",
    "dashboard.tools.mockInterview": "Mock Interview",
    "dashboard.tools.mockInterviewDesc": "Practice with AI interviewer",
    "dashboard.tools.jobMatch": "Job Matcher",
    "dashboard.tools.jobMatchDesc": "Match CV to job descriptions",
    "dashboard.tools.salaryGuide": "SA Salary Guide",
    "dashboard.tools.salaryGuideDesc": "Know your worth",
    "dashboard.tools.skills": "Skills Gap",
    "dashboard.tools.skillsDesc": "Find courses to upskill",
    "dashboard.tools.tracker": "Application Tracker",
    "dashboard.tools.trackerDesc": "Track your job applications",
    "dashboard.tools.resources": "SA Resources",
    "dashboard.tools.resourcesDesc": "Workplace rights & guides",
    "dashboard.subscription.active": "Subscription Active",
    "dashboard.subscription.expires": "Expires",
    "dashboard.subscription.renew": "Renew Subscription",
    "dashboard.subscription.subscribe": "Subscribe",
    "dashboard.subscription.locked": "Feature Locked",
    "dashboard.subscription.unlockMsg": "Subscribe for R25 for 30 days to unlock all features",
    "dashboard.cv.edit": "Edit",
    "dashboard.cv.preview": "Preview",
    "dashboard.cv.download": "Download",
    "dashboard.cv.delete": "Delete",
    "dashboard.cv.share": "Share",
    "dashboard.cv.lastUpdated": "Last updated",
    "dashboard.cv.atsScore": "ATS Score",
    "dashboard.sidebar.dashboard": "Dashboard",
    "dashboard.sidebar.cvBuilder": "CV Builder",
    "dashboard.sidebar.coverLetter": "Cover Letter",
    "dashboard.sidebar.interview": "Interview Prep",
    "dashboard.sidebar.jobTracker": "Job Tracker",
    "dashboard.sidebar.salaryGuide": "Salary Guide",
    "dashboard.sidebar.settings": "Settings",
    "dashboard.sidebar.logout": "Logout",
    "dashboard.sidebar.admin": "Admin Panel",
    "dashboard.quickActions": "Quick Actions",
    "dashboard.recentActivity": "Recent Activity",
    
    // CV Builder
    "cv.builder.title": "CV Builder",
    "cv.builder.save": "Save",
    "cv.builder.preview": "Preview",
    "cv.builder.download": "Download PDF",
    "cv.builder.step.personal": "Personal Details",
    "cv.builder.step.summary": "Summary",
    "cv.builder.step.experience": "Experience",
    "cv.builder.step.education": "Education",
    "cv.builder.step.skills": "Skills",
    "cv.builder.step.references": "References",
    
    // Personal Details
    "cv.personal.fullName": "Full Name",
    "cv.personal.email": "Email Address",
    "cv.personal.phone": "Phone Number",
    "cv.personal.city": "City",
    "cv.personal.province": "Province",
    "cv.personal.nationality": "Nationality",
    "cv.personal.driversLicense": "Driver's License",
    "cv.personal.ownTransport": "Own Transport",
    
    // Common Actions
    "common.save": "Save",
    "common.cancel": "Cancel",
    "common.delete": "Delete",
    "common.edit": "Edit",
    "common.add": "Add",
    "common.remove": "Remove",
    "common.next": "Next",
    "common.previous": "Previous",
    "common.loading": "Loading...",
    "common.submit": "Submit",
    "common.download": "Download",
    "common.share": "Share",
    "common.preview": "Preview",
    
    // Auth
    "auth.login": "Log In",
    "auth.register": "Register",
    "auth.email": "Email",
    "auth.password": "Password",
    "auth.confirmPassword": "Confirm Password",
    "auth.fullName": "Full Name",
    "auth.forgotPassword": "Forgot Password?",
    "auth.noAccount": "Don't have an account?",
    "auth.hasAccount": "Already have an account?",
    "auth.signUp": "Sign Up",
    
    // Chatbot
    "chatbot.title": "Career Step Assistant",
    "chatbot.subtitle": "CV & Job Search Help",
    "chatbot.placeholder": "Ask about CVs, interviews, jobs...",
    "chatbot.securityNote": "For security, links are blocked. Ask work-related questions only.",
    "chatbot.welcome": "Hi! I'm the Career Step assistant. I can help you with:\n\n• CV writing tips\n• Interview preparation\n• Job search advice\n• Using Career Step features\n• South African job market info\n\nHow can I help you today?",
    
    // WhatsApp Share
    "share.whatsapp": "Share on WhatsApp",
    "share.whatsappMessage": "Check out my professional CV created with Career Step!",
    
    // Footer
    "footer.privacy": "Privacy Policy",
    "footer.terms": "Terms of Service",
    "footer.cookies": "Cookie Policy",
    "footer.copyright": "© 2025 Career Step. All rights reserved.",
    
    // About Page
    "about.title": "About Career Step",
    "about.subtitle": "Helping South Africans create professional, honest CVs that get them hired.",
    "about.back": "Back",
    "about.mission.title": "Our Mission",
    "about.mission.text": "Career Step exists to help job seekers in South Africa present themselves professionally and honestly. We believe everyone deserves access to tools that were once only available to those who could afford expensive CV writers or career coaches.",
    "about.problem.title": "The Problem We Solve",
    "about.problem.intro": "Every day, qualified South Africans miss out on jobs because:",
    "about.problem.1": "Their CVs don't pass automated screening systems (ATS)",
    "about.problem.2": "They don't know how to present their experience professionally",
    "about.problem.3": "Professional CV services charge R500-R2000+ per CV",
    "about.problem.4": "They don't know what salary to expect or how to prepare for interviews",
    "about.problem.solution": "Career Step solves all of this for just R25 for 30 days — less than a takeaway meal.",
    "about.values.title": "What We Stand For",
    "about.values.honesty.title": "Honesty First",
    "about.values.honesty.text": "We help you present your real experience in the best light. We will never help you fake qualifications or invent experience. Employers value honesty, and so do we.",
    "about.values.affordable.title": "Affordable Access",
    "about.values.affordable.text": "Professional tools shouldn't only be for those who can afford expensive services. At R25 for 30 days, Career Step is accessible to everyone serious about their job search.",
    "about.values.local.title": "Built for SA",
    "about.values.local.text": "We understand the South African job market. Our salary data, workplace rights information, and CV formats are all tailored for local employers and standards.",
    "about.features.title": "What You Get",
    "about.features.1": "Professional CV builder with ATS-friendly templates",
    "about.features.2": "Up to 6 different CVs for different job types",
    "about.features.3": "Cover letter generator tailored to each job",
    "about.features.4": "Job application tracker to stay organised",
    "about.features.5": "SA salary data so you know your worth",
    "about.features.6": "Interview preparation tools",
    "about.features.7": "Skills gap analysis with free course recommendations",
    "about.features.8": "Workplace rights information",
    "about.features.9": "Email templates for follow-ups",
    "about.features.10": "Career path planning",
    "about.stats.templates": "ATS-Friendly Templates",
    "about.stats.profiles": "SA Job Profiles",
    "about.stats.provinces": "Provinces Covered",
    "about.cta.title": "Ready to Take the Next Step?",
    "about.cta.text": "Join thousands of South Africans who are taking control of their job search with professional tools.",
    "about.cta.button": "Get Started - R25 for 30 Days",
    "about.cta.login": "Already have an account? Login",
    "about.contact.title": "Questions?",
    "about.contact.text": "Email us at",
    
    // Login Page
    "login.title": "Welcome back",
    "login.subtitle": "Log in to continue building your CV",
    "login.email": "Email",
    "login.password": "Password",
    "login.forgotPassword": "Forgot password?",
    "login.submit": "Log In",
    "login.submitting": "Logging in...",
    "login.noAccount": "Don't have an account?",
    "login.signUp": "Sign up",
    "login.testimonial": "Career Step helped me land my first job. The AI made my limited experience sound professional without lying.",
    "login.testimonialAuthor": "— Thabo M., Cape Town",
    
    // Register Page
    "register.title": "Create Your Account",
    "register.subtitle": "Start building your professional CV today",
    "register.fullName": "Full Name",
    "register.fullNamePlaceholder": "Your full name",
    "register.email": "Email",
    "register.emailPlaceholder": "you@example.com",
    "register.password": "Password",
    "register.passwordPlaceholder": "Create a strong password",
    "register.passwordReq.length": "At least 8 characters",
    "register.passwordReq.upper": "One uppercase letter",
    "register.passwordReq.number": "One number",
    "register.submit": "Create Account",
    "register.submitting": "Creating Account...",
    "register.hasAccount": "Already have an account?",
    "register.login": "Log In",
    "register.terms": "By creating an account, you agree to our",
    "register.termsLink": "Terms",
    "register.privacyLink": "Privacy Policy",
    "register.success.title": "Welcome to Career Step!",
    "register.success.text": "Your account has been created successfully. Redirecting you to login...",
    "register.success.redirecting": "Redirecting...",
    "register.success.button": "Go to Login Now",
    "register.success.hint": "You can now log in and start creating your professional CV!",
    
    // Landing Page Extended
    "landing.successStories.badge": "Real Results",
    "landing.successStories.title": "They Did It. So Can You.",
    "landing.successStories.subtitle": "Real South Africans who transformed their careers with Career Step",
    "landing.successStories.before": "BEFORE",
    "landing.successStories.after": "AFTER",
    "landing.successStories.keyFeature": "Key Feature:",
    "landing.successStories.cta": "Ready to write your success story?",
    "landing.successStories.button": "Get Started for Just R25",
    "landing.motivation.text1": "Don't let",
    "landing.motivation.text2": "stand between you and your next job.",
    "landing.motivation.subtext": "Your career is worth more than a cup of coffee. Invest in yourself today.",
    "landing.features.title": "Everything You Need to Get Hired",
    "landing.features.subtitle": "From CV creation to interview prep, we've got you covered.",
    "landing.features.ats.title": "ATS-Friendly CVs",
    "landing.features.ats.desc": "Create professional CVs that pass Applicant Tracking Systems used by SA employers.",
    "landing.features.match.title": "Job Matching",
    "landing.features.match.desc": "Match your CV against job descriptions and get honest ATS compatibility scores.",
    "landing.features.interview.title": "Interview Prep",
    "landing.features.interview.desc": "AI-generated interview questions based on YOUR actual experience.",
    "landing.features.pdf.title": "Clean PDF Export",
    "landing.features.pdf.desc": "Download professional, ATS-readable PDFs. No watermarks, ever.",
    "landing.ats.badge": "ATS-Approved Templates",
    "landing.ats.title": "Your CV Will Actually Get Seen",
    "landing.ats.subtitle": "90% of companies use Applicant Tracking Systems (ATS) to filter CVs before a human ever sees them. Our templates are built to pass through these systems.",
    "landing.ats.feature1.title": "Clean Single-Column Layout",
    "landing.ats.feature1.desc": "No confusing tables or columns that ATS systems can't read properly",
    "landing.ats.feature2.title": "Standard Professional Fonts",
    "landing.ats.feature2.desc": "Helvetica and other fonts that every system recognizes perfectly",
    "landing.ats.feature3.title": "Clear Section Headers",
    "landing.ats.feature3.desc": "EXPERIENCE, EDUCATION, SKILLS - labelled exactly how ATS expects",
    "landing.ats.feature4.title": "No Hidden Text or Graphics",
    "landing.ats.feature4.desc": "Every word is readable text, not buried in images or graphics",
    "landing.ats.feature5.title": "Keyword Optimized",
    "landing.ats.feature5.desc": "Our AI helps match your CV to job descriptions for better ranking",
    "landing.ats.feature6.title": "Tested & Verified",
    "landing.ats.feature6.desc": "All 6 templates tested against major ATS systems used in SA",
    "landing.ats.tip": "Don't waste time on a CV that gets automatically rejected. Our templates are designed to get you to the interview.",
    "landing.cvTypes.title": "A CV Template for Every Stage",
    "landing.cvTypes.subtitle": "Whether you're starting out or switching careers, we've got you covered.",
    "landing.cvTypes.noExp.title": "No Experience",
    "landing.cvTypes.noExp.desc": "First-time job seekers, school leavers",
    "landing.cvTypes.entry.title": "Entry-Level",
    "landing.cvTypes.entry.desc": "Matric holders, interns, graduates",
    "landing.cvTypes.exp.title": "Experienced",
    "landing.cvTypes.exp.desc": "Workers with job history",
    "landing.cvTypes.switch.title": "Career Switcher",
    "landing.cvTypes.switch.desc": "Changing industries or roles",
    "landing.translator.badge": "AI-Powered",
    "landing.translator.title": "Turn Informal Experience into Professional Words",
    "landing.translator.subtitle": "Have informal work experience? Our AI translates it into professional CV language—without exaggerating or lying.",
    "landing.translator.input": "You type:",
    "landing.translator.inputExample": "Helped at family shop",
    "landing.translator.output": "AI rewrites:",
    "landing.translator.outputExample": "Assisted with customer service, stock handling, and daily operations in a family-run retail environment.",
    "landing.translator.cta.title": "Start Today",
    "landing.translator.cta.1": "No credit card required to start",
    "landing.translator.cta.2": "Cancel anytime, no penalties",
    "landing.translator.cta.3": "Full features from day one",
    "landing.translator.cta.button": "Get Started - R25",
    "landing.finalCta.title": "Your Dream Job is Waiting",
    "landing.finalCta.subtitle": "Don't let R25 be the reason you miss out on your next opportunity",
    "landing.finalCta.price": "R25",
    "landing.finalCta.period": "30 Days Full Access",
    "landing.finalCta.note": "Your data stays safe forever • Pay only when you need it",
    "landing.finalCta.feature1": "Up to 6 professional CVs",
    "landing.finalCta.feature2": "AI-powered CV enhancement",
    "landing.finalCta.feature3": "AI Mock Interviewer",
    "landing.finalCta.feature4": "Cover Letter Builder",
    "landing.finalCta.feature5": "Job matching & ATS scoring",
    "landing.finalCta.feature6": "Unlimited PDF downloads",
    "landing.finalCta.feature7": "SA Job resources & guides",
    "landing.finalCta.button": "Invest in Your Future - R25",
    "landing.finalCta.secure": "Secure payment • Cancel anytime • No hidden fees",
    "landing.footer.brand": "Career Step",
    "landing.footer.brandDesc": "Professional CV creation for South African job seekers. We help you present your real experience professionally.",
    "landing.footer.quickLinks": "Quick Links",
    "landing.footer.getStarted": "Get Started",
    "landing.footer.login": "Log In",
    "landing.footer.about": "About Us",
    "landing.footer.legal": "Legal",
    "landing.footer.connect": "Connect",
    "landing.footer.facebook": "Facebook",
    "landing.footer.copyright": "Made with care in South Africa.",
    "landing.footer.promise": "We do not create fake experience. Your information stays private.",
  },
  
  zu: {
    // Header & Navigation
    "nav.about": "Mayelana",
    "nav.login": "Ngena",
    "nav.getStarted": "Thola Izinsuku Ezingu-30 ngo-R25",
    "nav.dashboard": "Ideshibhodi",
    "nav.logout": "Phuma",
    
    // Landing Page
    "landing.badge": "Yakhelwe Abafuna Umsebenzi baseNingizimu Afrika",
    "landing.title": "Thola Umsebenzi Wakho Wephupho",
    "landing.titleHighlight": "nge-CV Eqinisekile",
    "landing.subtitle": "Dala ama-CV ahlanzekile, ahambisana ne-ATS abonisa ulwazi lwakho lwangempela. Akukho iziqu ezingamanga. Akukho amakhono aqanjiwe. Nguwe kuphela, uboniswe ngobuchwepheshe.",
    "landing.cta": "Qala Ukwakha I-CV Yakho",
    "landing.pricing.bestValue": "INANI ELIHLE",
    "landing.pricing.title": "Izinsuku Ezingu-30 Zokufinyelela Okuphelele",
    "landing.pricing.price": "R25",
    "landing.pricing.period": "kanye kuphela",
    "landing.pricing.features.cvs": "Kufinyelela ku-6 ama-CV",
    "landing.pricing.features.ai": "Ukuthuthukiswa kwe-CV okusekelwa yi-AI",
    "landing.pricing.features.interview": "Ukuprakthiza Inhlolokhono ye-AI",
    "landing.pricing.features.matching": "Ukufaniswa komsebenzi nesikali se-ATS",
    "landing.pricing.features.pdf": "Ukudawuniloda i-PDF okungenamkhawulo",
    "landing.pricing.cta": "Qala Manje",
    "landing.pricing.note": "Akukho ukuvuselelwa okuzenzakalelayo • Idatha yakho ihlala iphephile",
    "landing.promise": "Isithembiso Sethu:",
    "landing.promiseText": "Asiqambi ulwazi noma iziqu. I-CV yakho iqukethe kuphela okuhlinzekayo.",
    
    // Dashboard
    "dashboard.welcome": "Siyakwamukela futhi",
    "dashboard.myCvs": "Ama-CV Ami",
    "dashboard.createCv": "Dala I-CV Entsha",
    "dashboard.noCvs": "Awukadalanga ama-CV okwamanje",
    "dashboard.noCvsSubtext": "Dala i-CV yakho yokuqala yobuchwepheshe ngemizuzu",
    "dashboard.stats.cvs": "Ama-CV Adalwe",
    "dashboard.stats.downloads": "Okudawunilodwe",
    "dashboard.stats.atsScore": "Isikali se-ATS Esilinganiselwe",
    "dashboard.stats.applications": "Izicelo",
    "dashboard.tools": "Amathuluzi Omsebenzi",
    "dashboard.tools.coverLetter": "Incwadi Yokufaka Isicelo",
    "dashboard.tools.coverLetterDesc": "Dala izincwadi ezifanele",
    "dashboard.tools.interview": "Ukulungiselela Inhlolokhono",
    "dashboard.tools.interviewDesc": "Inhlolokhono yokuqeqeshwa ye-AI",
    "dashboard.tools.mockInterview": "Inhlolokhono Yokuqeqeshwa",
    "dashboard.tools.mockInterviewDesc": "Qeqesha nomhloli we-AI",
    "dashboard.tools.jobMatch": "Ukufanisa Umsebenzi",
    "dashboard.tools.jobMatchDesc": "Fanisa i-CV nencazelo yomsebenzi",
    "dashboard.tools.salaryGuide": "Umhlahlandlela Wemiholo yase-SA",
    "dashboard.tools.salaryGuideDesc": "Yazi ukuthi ufanele malini",
    "dashboard.tools.skills": "Izikhala Zamakhono",
    "dashboard.tools.skillsDesc": "Thola izifundo zokuthuthuka",
    "dashboard.tools.tracker": "Umlandeli Wezicelo",
    "dashboard.tools.trackerDesc": "Landela izicelo zakho zomsebenzi",
    "dashboard.tools.resources": "Izinsiza zase-SA",
    "dashboard.tools.resourcesDesc": "Amalungelo asekusebenzeni & imihlahlandlela",
    "dashboard.subscription.active": "Ukubhalisela Kusebenza",
    "dashboard.subscription.expires": "Kuphela",
    "dashboard.subscription.renew": "Vuselela Ukubhalisa",
    "dashboard.subscription.subscribe": "Bhalisa",
    "dashboard.subscription.locked": "Isici Sivaliwe",
    "dashboard.subscription.unlockMsg": "Bhalisa ngo-R25 izinsuku ezingu-30 ukuvula zonke izici",
    "dashboard.cv.edit": "Hlela",
    "dashboard.cv.preview": "Buka Kuqala",
    "dashboard.cv.download": "Dawuniloda",
    "dashboard.cv.delete": "Susa",
    "dashboard.cv.share": "Yabelana",
    "dashboard.cv.lastUpdated": "Kugcine ukuvuselelwa",
    "dashboard.cv.atsScore": "Isikali se-ATS",
    "dashboard.sidebar.dashboard": "Ideshibhodi",
    "dashboard.sidebar.cvBuilder": "Umakhi we-CV",
    "dashboard.sidebar.coverLetter": "Incwadi Yokufaka Isicelo",
    "dashboard.sidebar.interview": "Ukulungiselela Inhlolokhono",
    "dashboard.sidebar.jobTracker": "Umlandeli Womsebenzi",
    "dashboard.sidebar.salaryGuide": "Umhlahlandlela Wemiholo",
    "dashboard.sidebar.settings": "Izilungiselelo",
    "dashboard.sidebar.logout": "Phuma",
    "dashboard.sidebar.admin": "Iphaneli Labaphathi",
    "dashboard.quickActions": "Izenzo Ezisheshayo",
    "dashboard.recentActivity": "Okwenzekile Kamuva",
    
    // CV Builder
    "cv.builder.title": "Umakhi we-CV",
    "cv.builder.save": "Londoloza",
    "cv.builder.preview": "Buka Kuqala",
    "cv.builder.download": "Dawuniloda i-PDF",
    "cv.builder.step.personal": "Imininingwane Yakho",
    "cv.builder.step.summary": "Isifinyezo",
    "cv.builder.step.experience": "Ulwazi",
    "cv.builder.step.education": "Imfundo",
    "cv.builder.step.skills": "Amakhono",
    "cv.builder.step.references": "Izinkomba",
    
    // Personal Details
    "cv.personal.fullName": "Igama Eliphelele",
    "cv.personal.email": "Ikheli Le-imeyili",
    "cv.personal.phone": "Inombolo Yocingo",
    "cv.personal.city": "Idolobha",
    "cv.personal.province": "Isifundazwe",
    "cv.personal.nationality": "Ubuzwe",
    "cv.personal.driversLicense": "Ilayisense Lokushayela",
    "cv.personal.ownTransport": "Isithuthi Sakho",
    
    // Common Actions
    "common.save": "Londoloza",
    "common.cancel": "Khansela",
    "common.delete": "Susa",
    "common.edit": "Hlela",
    "common.add": "Engeza",
    "common.remove": "Susa",
    "common.next": "Okulandelayo",
    "common.previous": "Okwedlule",
    "common.loading": "Iyalayisha...",
    "common.submit": "Thumela",
    "common.download": "Dawuniloda",
    "common.share": "Yabelana",
    "common.preview": "Buka Kuqala",
    
    // Auth
    "auth.login": "Ngena",
    "auth.register": "Bhalisa",
    "auth.email": "I-imeyili",
    "auth.password": "Iphasiwedi",
    "auth.confirmPassword": "Qinisekisa Iphasiwedi",
    "auth.fullName": "Igama Eliphelele",
    "auth.forgotPassword": "Ukhohlwe Iphasiwedi?",
    "auth.noAccount": "Awunayo i-akhawunti?",
    "auth.hasAccount": "Usunayo i-akhawunti?",
    "auth.signUp": "Bhalisa",
    
    // Chatbot
    "chatbot.title": "Umsizi we-Career Step",
    "chatbot.subtitle": "Usizo Lwe-CV Nokufuna Umsebenzi",
    "chatbot.placeholder": "Buza ngama-CV, izinhlolokhono, imisebenzi...",
    "chatbot.securityNote": "Ngokuphepha, izixhumanisi zivinjiwe. Buza imibuzo ephathelene nomsebenzi kuphela.",
    "chatbot.welcome": "Sawubona! Ngingumsizi we-Career Step. Ngingakusiza nge:\n\n• Amathiphu okubhala i-CV\n• Ukulungiselela inhlolokhono\n• Izeluleko zokufuna umsebenzi\n• Ukusebenzisa izici ze-Career Step\n• Ulwazi lwemakethe yomsebenzi yaseNingizimu Afrika\n\nNgingakusiza ngani namuhla?",
    
    // WhatsApp Share
    "share.whatsapp": "Yabelana ku-WhatsApp",
    "share.whatsappMessage": "Bheka i-CV yami yobuchwepheshe eyenziwe nge-Career Step!",
    
    // Footer
    "footer.privacy": "Inqubomgomo Yobumfihlo",
    "footer.terms": "Imigomo Yesevisi",
    "footer.cookies": "Inqubomgomo Yamakhukhi",
    "footer.copyright": "© 2025 Career Step. Wonke amalungelo agodliwe.",
    
    // About Page
    "about.title": "Mayelana ne-Career Step",
    "about.subtitle": "Sisiza abantu baseNingizimu Afrika ukwenza ama-CV ahlanzekile, athembekile abathola umsebenzi.",
    "about.back": "Emuva",
    "about.mission.title": "Inhloso Yethu",
    "about.mission.text": "I-Career Step ikhona ukusiza abafuna umsebenzi baseNingizimu Afrika bazethule ngendlela efanele nethembekile. Sikholelwa ukuthi wonke umuntu ufanelwe ukufinyelela amathuluzi abengafinyeleleka kuphela kulabo abanokukhokhela ababhali be-CV abadure noma abaqondisi bomsebenzi.",
    "about.problem.title": "Inkinga Esiyixazululayo",
    "about.problem.intro": "Nsuku zonke, abantu baseNingizimu Afrika abanokuqeqeshwa bayalahlekelwa umsebenzi ngoba:",
    "about.problem.1": "Ama-CV abo awadluli ezinhlelweni zokuhlola ezizenzakalelayo (ATS)",
    "about.problem.2": "Abazi ukuthi bangabethula kanjani ulwazi lwabo ngendlela efanele",
    "about.problem.3": "Izinsizakalo ze-CV zasebunyeni zikhokhisa u-R500-R2000+ nge-CV",
    "about.problem.4": "Abazi ukuthi imali engakanani abalindelwe ukuyithola noma ukulungiselela kanjani izinhlolokhono",
    "about.problem.solution": "I-Career Step ixazulula konke lokhu ngo-R25 kuphela izinsuku ezingu-30 — ngaphansi kwekukudla okuthengwayo.",
    "about.values.title": "Esikumelele",
    "about.values.honesty.title": "Ukwethembeka Kuqala",
    "about.values.honesty.text": "Sikusize ukwethula ulwazi lwakho lwangempela ngendlela enhle kakhulu. Asikaze sikusize ukuqamba iziqu noma ukwenza ulwazi. Abaqashi bayakuthanda ukwethembeka, nathi siyakuthanda.",
    "about.values.affordable.title": "Ukufinyelela Okushibhile",
    "about.values.affordable.text": "Amathuluzi abunyeni akufanele abe ngawalabo kuphela abanokukhokhela izinsizakalo ezidure. Ngo-R25 izinsuku ezingu-30, i-Career Step iyafinyeleka kuwo wonke umuntu onobuhlobo nokufuna umsebenzi.",
    "about.values.local.title": "Yakhelwe i-SA",
    "about.values.local.text": "Siyayiqonda imakethe yomsebenzi yaseNingizimu Afrika. Idatha yethu yemiholo, ulwazi lwamalungelo asekusebenzeni, namafomu e-CV konke kwenzelwe abaqashi bendawo nezindinganiso.",
    "about.features.title": "Okuthola",
    "about.features.1": "Umakhi we-CV wabunyeni namatempleti alungele i-ATS",
    "about.features.2": "Kufinyelela ku-6 ama-CV ahlukahlukene ezinhlobo zomsebenzi ezahlukahlukene",
    "about.features.3": "Umakhi wencwadi yokufaka isicelo elungiselelwe umsebenzi ngamunye",
    "about.features.4": "Isilandeli sokufaka isicelo somsebenzi ukuhlala uhlelekile",
    "about.features.5": "Idatha yemiholo yase-SA ukuze wazi ukuthi ufanele malini",
    "about.features.6": "Amathuluzi okulungiselela inhlolokhono",
    "about.features.7": "Ukuhlaziya izikhala zamakhono nezincomo zezifundo zamahhala",
    "about.features.8": "Ulwazi lwamalungelo asekusebenzeni",
    "about.features.9": "Amatempleti e-imeyili okulandela",
    "about.features.10": "Ukuhlela indlela yomsebenzi",
    "about.stats.templates": "Amatempleti alungele i-ATS",
    "about.stats.profiles": "Amaphrofayili Omsebenzi ase-SA",
    "about.stats.provinces": "Izifundazwe Ezihlanganisiwe",
    "about.cta.title": "Ukulungele Ukuthatha Isinyathelo Esilandelayo?",
    "about.cta.text": "Joyina izinkulungwane zabantu baseNingizimu Afrika abathatha ulawulo lokufuna kwabo umsebenzi ngamathuluzi abunyeni.",
    "about.cta.button": "Qala - R25 Izinsuku Ezingu-30",
    "about.cta.login": "Usunayo i-akhawunti? Ngena",
    "about.contact.title": "Imibuzo?",
    "about.contact.text": "Sithumelele i-imeyili ku",
    
    // Login Page
    "login.title": "Siyakwamukela futhi",
    "login.subtitle": "Ngena ukuze uqhubeke nokwakha i-CV yakho",
    "login.email": "I-imeyili",
    "login.password": "Iphasiwedi",
    "login.forgotPassword": "Ukhohlwe iphasiwedi?",
    "login.submit": "Ngena",
    "login.submitting": "Kuyangena...",
    "login.noAccount": "Awunayo i-akhawunti?",
    "login.signUp": "Bhalisa",
    "login.testimonial": "I-Career Step ingisizile ukuthola umsebenzi wami wokuqala. I-AI yenze ulwazi lwami oluncane lwazwakala ngendlela efanele ngaphandle kokuqamba.",
    "login.testimonialAuthor": "— Thabo M., Cape Town",
    
    // Register Page
    "register.title": "Dala I-akhawunti Yakho",
    "register.subtitle": "Qala ukwakha i-CV yakho yabunyeni namuhla",
    "register.fullName": "Igama Eliphelele",
    "register.fullNamePlaceholder": "Igama lakho eliphelele",
    "register.email": "I-imeyili",
    "register.emailPlaceholder": "wena@isibonelo.com",
    "register.password": "Iphasiwedi",
    "register.passwordPlaceholder": "Dala iphasiwedi enamandla",
    "register.passwordReq.length": "Okungenani izinhlamvu ezingu-8",
    "register.passwordReq.upper": "Uhlamvu olulodwa olukhulu",
    "register.passwordReq.number": "Inombolo eyodwa",
    "register.submit": "Dala I-akhawunti",
    "register.submitting": "Kuyadalwa I-akhawunti...",
    "register.hasAccount": "Usunayo i-akhawunti?",
    "register.login": "Ngena",
    "register.terms": "Ngokudala i-akhawunti, uyavumelana ne",
    "register.termsLink": "Imigomo",
    "register.privacyLink": "Inqubomgomo Yobumfihlo",
    "register.success.title": "Siyakwamukela ku-Career Step!",
    "register.success.text": "I-akhawunti yakho idaliwe ngempumelelo. Siyakuthumela ekungenisweni...",
    "register.success.redirecting": "Kuyathunyelwa...",
    "register.success.button": "Iya Ekungeneni Manje",
    "register.success.hint": "Manje ungangena uqale ukwenza i-CV yakho yabunyeni!",
    
    // Landing Page Extended
    "landing.successStories.badge": "Imiphumela Yangempela",
    "landing.successStories.title": "Bakwenzile. Nawe Ungakwenza.",
    "landing.successStories.subtitle": "AbaseNingizimu Afrika bangempela abaguqule imisebenzi yabo nge-Career Step",
    "landing.successStories.before": "NGAPHAMBI",
    "landing.successStories.after": "NGEMUVA",
    "landing.successStories.keyFeature": "Isici Esibalulekile:",
    "landing.successStories.cta": "Ukulungele ukubhala indaba yakho yempumelelo?",
    "landing.successStories.button": "Qala ngo-R25 Kuphela",
    "landing.motivation.text1": "Ungavumeli",
    "landing.motivation.text2": "kume phakathi kwakho nomsebenzi wakho olandelayo.",
    "landing.motivation.subtext": "Umsebenzi wakho ubaluleke kakhulu kunekophi likhofi. Tshala imali kuwena namuhla.",
    "landing.features.title": "Konke Okudingayo Ukuze Uqashwe",
    "landing.features.subtitle": "Kusukela ekwakheni i-CV kuya ekulungiseleleni inhlolokhono, sikugadle.",
    "landing.features.ats.title": "Ama-CV Alungele i-ATS",
    "landing.features.ats.desc": "Dala ama-CV abunyeni adlula Ezinhlelweni Zokulandela Abafaki Zicelo ezisetshenziswa abaqashi base-SA.",
    "landing.features.match.title": "Ukufanisa Umsebenzi",
    "landing.features.match.desc": "Fanisa i-CV yakho nezincazelo zomsebenzi futhi uthole amaphuzu okuhambisana ne-ATS athembekile.",
    "landing.features.interview.title": "Ukulungiselela Inhlolokhono",
    "landing.features.interview.desc": "Imibuzo yenhlolokhono edalwe yi-AI esekelwe kulwazi LWAKHO lwangempela.",
    "landing.features.pdf.title": "Ukudawuniloda i-PDF Ehlanzekile",
    "landing.features.pdf.desc": "Dawuniloda ama-PDF abunyeni, afundeka yi-ATS. Akukho amamaki amanzi, nanini.",
    "landing.ats.badge": "Amatempleti Avunywe yi-ATS",
    "landing.ats.title": "I-CV Yakho Izobonwa Ngempela",
    "landing.ats.subtitle": "90% yezinkampani zisebenzisa Izinhlelo Zokulandela Abafaki Zicelo (ATS) ukuhlungela ama-CV ngaphambi kokuthi umuntu ayibone. Amatempleti ethu akhiwe ukudlula kulezi zinhlelo.",
    "landing.ats.feature1.title": "Isakhiwo Sekholomu Eyodwa Esihlanzekile",
    "landing.ats.feature1.desc": "Akukho amatafula noma amakholomu adidanisayo izinhlelo ze-ATS ezingakwazi ukuzifunda kahle",
    "landing.ats.feature2.title": "Amafonti Asezingeni Eliphakeme",
    "landing.ats.feature2.desc": "I-Helvetica namanye amafonti wonke uhlelo oluwabonayo ngokuphelele",
    "landing.ats.feature3.title": "Izihloko Zezigaba Ezicacile",
    "landing.ats.feature3.desc": "ULWAZI, IMFUNDO, AMAKHONO - abhalwe ngqo njengoba i-ATS ilindele",
    "landing.ats.feature4.title": "Akukho Umbhalo Ofihliwe Noma Izithombe",
    "landing.ats.feature4.desc": "Yonke igama umbhalo ofundekayo, awugodliwe ezithombeni noma kuzithombe",
    "landing.ats.feature5.title": "Kulungiselelwe Amagama Abalulekile",
    "landing.ats.feature5.desc": "I-AI yethu isiza ukufanisa i-CV yakho nezincazelo zomsebenzi ukuze ukude kangcono",
    "landing.ats.feature6.title": "Kuhlolwe & Kuqinisekisiwe",
    "landing.ats.feature6.desc": "Wonke amatempleti angu-6 ahlolwe ngokumelene nezinhlelo ezinkulu ze-ATS ezisetshenziswa e-SA",
    "landing.ats.tip": "Ungachithi isikhathi nge-CV enqatshelwe ngokuzenzakalelayo. Amatempleti ethu enzelwe ukukusa enhlolokhonweni.",
    "landing.cvTypes.title": "Itempleti le-CV Lesigaba Ngasinye",
    "landing.cvTypes.subtitle": "Noma ngabe uqala noma ushintsha imisebenzi, sikugadle.",
    "landing.cvTypes.noExp.title": "Akunalwazi",
    "landing.cvTypes.noExp.desc": "Abafuna umsebenzi okokuqala, abaphuma esikoleni",
    "landing.cvTypes.entry.title": "Izinga Lokuqala",
    "landing.cvTypes.entry.desc": "Abanomatikuletsheni, abasebenzela ukufunda, abaphothulile",
    "landing.cvTypes.exp.title": "Olwazi",
    "landing.cvTypes.exp.desc": "Abasebenzi abanomlando womsebenzi",
    "landing.cvTypes.switch.title": "Oshintsha Umsebenzi",
    "landing.cvTypes.switch.desc": "Ushintsha izimboni noma izikhundla",
    "landing.translator.badge": "Ikusekelwa yi-AI",
    "landing.translator.title": "Guqula Ulwazi Olungenamthetho Lube Amagama Abunyeni",
    "landing.translator.subtitle": "Unolwazi lomsebenzi olungenamthetho? I-AI yethu iyakuhumusha kube ulimi lwe-CV olungqungquthela—ngaphandle kokwandisa noma ukukhuluma amanga.",
    "landing.translator.input": "Ubhala:",
    "landing.translator.inputExample": "Ngisizile esitolo somndeni",
    "landing.translator.output": "I-AI ibhala kabusha:",
    "landing.translator.outputExample": "Ngisize ngezinsizakalo zamakhasimende, ukuphatha isitoko, nokusebenza kwansuku zonke endaweni yokuthengisa yomndeni.",
    "landing.translator.cta.title": "Qala Namuhla",
    "landing.translator.cta.1": "Akudingeki ikhadi lesikweletu ukuqala",
    "landing.translator.cta.2": "Khansela noma nini, akukho izinhlawulo",
    "landing.translator.cta.3": "Zonke izici kusukela ngosuku lokuqala",
    "landing.translator.cta.button": "Qala - R25",
    "landing.finalCta.title": "Umsebenzi Wakho Wephupho Uyalinda",
    "landing.finalCta.subtitle": "Ungavumeli u-R25 kube isisusa sokuthi ungalutholi ithuba lakho elilandelayo",
    "landing.finalCta.price": "R25",
    "landing.finalCta.period": "Izinsuku Ezingu-30 Zokufinyelela Okuphelele",
    "landing.finalCta.note": "Idatha yakho ihlala iphephile phakade • Khokha kuphela lapho udinga",
    "landing.finalCta.feature1": "Kufinyelela ku-6 ama-CV abunyeni",
    "landing.finalCta.feature2": "Ukuthuthukiswa kwe-CV okusekelwa yi-AI",
    "landing.finalCta.feature3": "Umhloli Wenhlolokhono we-AI",
    "landing.finalCta.feature4": "Umakhi Wencwadi Yokufaka Isicelo",
    "landing.finalCta.feature5": "Ukufaniswa komsebenzi & amaphuzu e-ATS",
    "landing.finalCta.feature6": "Ukudawuniloda i-PDF okungenamkhawulo",
    "landing.finalCta.feature7": "Izinsiza zemisebenzi yase-SA & imihlahlandlela",
    "landing.finalCta.button": "Tshala Imali Ekusaseni Lakho - R25",
    "landing.finalCta.secure": "Ukukhokha okuphephile • Khansela noma nini • Akukho izindleko ezifihliwe",
    "landing.footer.brand": "Career Step",
    "landing.footer.brandDesc": "Ukwakha i-CV yabunyeni yabafuna umsebenzi baseNingizimu Afrika. Sikusize ukwethula ulwazi lwakho lwangempela ngendlela efanele.",
    "landing.footer.quickLinks": "Izixhumanisi Ezisheshayo",
    "landing.footer.getStarted": "Qala",
    "landing.footer.login": "Ngena",
    "landing.footer.about": "Mayelana Nathi",
    "landing.footer.legal": "Okusemthethweni",
    "landing.footer.connect": "Xhuma",
    "landing.footer.facebook": "Facebook",
    "landing.footer.copyright": "Kwenziwe ngothando eNingizimu Afrika.",
    "landing.footer.promise": "Asidali ulwazi olungamanga. Ulwazi lwakho luhlala luyimfihlo.",
  },
  
  xh: {
    // Header & Navigation
    "nav.about": "Malunga",
    "nav.login": "Ngena",
    "nav.getStarted": "Fumana Iintsuku Ezingama-30 nge-R25",
    "nav.dashboard": "Idashbhodi",
    "nav.logout": "Phuma",
    
    // Landing Page
    "landing.badge": "Yenzelwe Abafuna Umsebenzi baseMzantsi Afrika",
    "landing.title": "Fumana Umsebenzi Wakho Wephupha",
    "landing.titleHighlight": "nge-CV Eyinyani",
    "landing.subtitle": "Yenza ii-CV zobungcali, ezilungele i-ATS ezibonisa amava akho okwenyani. Akukho ziqinisekiso zobuxoki. Akukho zakhono eziqanjiweyo. Nguwe kuphela, uboniswe ngobungcali.",
    "landing.cta": "Qala Ukwakha I-CV Yakho",
    "landing.pricing.title": "Iintsuku Ezingama-30 Zokufikelela Okupheleleyo",
    "landing.pricing.price": "R25",
    "landing.pricing.period": "ixesha elinye",
    "landing.pricing.features.cvs": "Ukuya kwii-CV ezintandathu",
    "landing.pricing.features.ai": "Ukuphuculwa kwe-CV ngamandla e-AI",
    "landing.pricing.features.interview": "Ukuzilolonga Kudliwanondlebe lwe-AI",
    "landing.pricing.features.matching": "Ukufaniswa komsebenzi namanqaku e-ATS",
    "landing.pricing.features.pdf": "Ukudawunloda i-PDF okungenasiphelo",
    "landing.pricing.cta": "Qala Ngoku",
    "landing.pricing.note": "Akukho kuhlaziya okuzenzekayo • Idatha yakho ihlala ikhuselekile",
    "landing.promise": "Isithembiso Sethu:",
    "landing.promiseText": "Asiqambi amava okanye iziqinisekiso. I-CV yakho iqulethe kuphela oko ukudibanisayo.",
    
    // Dashboard
    "dashboard.welcome": "Wamkelekile kwakhona",
    "dashboard.myCvs": "Ii-CV Zam",
    "dashboard.createCv": "Yenza I-CV Entsha",
    "dashboard.noCvs": "Awukenzanga ii-CV okwangoku",
    "dashboard.noCvsSubtext": "Yenza i-CV yakho yokuqala yobungcali ngemizuzu",
    "dashboard.stats.cvs": "Ii-CV Ezenziweyo",
    "dashboard.stats.downloads": "Ukudawunlodwa",
    "dashboard.stats.atsScore": "Amanqaku e-ATS Esiqhelekileyo",
    "dashboard.stats.applications": "Izicelo",
    "dashboard.tools": "Izixhobo Zomsebenzi",
    "dashboard.tools.coverLetter": "Incwadi Yokufaka Isicelo",
    "dashboard.tools.coverLetterDesc": "Yenza iincwadi ezilungiselelweyo",
    "dashboard.tools.interview": "Ukulungiselela Udliwano-ndlebe",
    "dashboard.tools.interviewDesc": "Udliwano-ndlebe lokuqeqeshwa lwe-AI",
    "dashboard.tools.mockInterview": "Udliwano-ndlebe Lokuqeqeshwa",
    "dashboard.tools.mockInterviewDesc": "Qeqesha nomvavanyi we-AI",
    "dashboard.tools.jobMatch": "Ukufaniswa Komsebenzi",
    "dashboard.tools.jobMatchDesc": "Fanisa i-CV nencazelo yomsebenzi",
    "dashboard.tools.salaryGuide": "Isikhokelo Semivuzo yase-SA",
    "dashboard.tools.salaryGuideDesc": "Yazi ukuba uxabiseke kangakanani",
    "dashboard.tools.skills": "Izikhewu Zezakhono",
    "dashboard.tools.skillsDesc": "Fumana izifundo zokuphucula",
    "dashboard.tools.tracker": "Umlandeli Wezicelo",
    "dashboard.tools.trackerDesc": "Landela izicelo zakho zomsebenzi",
    "dashboard.tools.resources": "Izixhobo zase-SA",
    "dashboard.tools.resourcesDesc": "Amalungelo ekusebenzeni & izikhokelo",
    "dashboard.subscription.active": "Ubhaliso Lusebenza",
    "dashboard.subscription.expires": "Luphela",
    "dashboard.subscription.renew": "Hlaziya Ubhaliso",
    "dashboard.subscription.subscribe": "Bhalisa",
    "dashboard.subscription.locked": "Uphawu Lutshixiwe",
    "dashboard.subscription.unlockMsg": "Bhalisa nge-R25 iintsuku ezingama-30 ukuvula zonke iimpawu",
    "dashboard.cv.edit": "Hlela",
    "dashboard.cv.preview": "Jonga Kuqala",
    "dashboard.cv.download": "Dawunloda",
    "dashboard.cv.delete": "Cima",
    "dashboard.cv.share": "Yabelana",
    "dashboard.cv.lastUpdated": "Ihlaziywe okokugqibela",
    "dashboard.cv.atsScore": "Amanqaku e-ATS",
    "dashboard.sidebar.dashboard": "Idashbhodi",
    "dashboard.sidebar.cvBuilder": "Umakhi we-CV",
    "dashboard.sidebar.coverLetter": "Incwadi Yokufaka Isicelo",
    "dashboard.sidebar.interview": "Ukulungiselela Udliwano-ndlebe",
    "dashboard.sidebar.jobTracker": "Umlandeli Womsebenzi",
    "dashboard.sidebar.salaryGuide": "Isikhokelo Semivuzo",
    "dashboard.sidebar.settings": "Izicwangciso",
    "dashboard.sidebar.logout": "Phuma",
    "dashboard.sidebar.admin": "Iphaneli Yolawulo",
    "dashboard.quickActions": "Izenzo Ezingxamisekileyo",
    "dashboard.recentActivity": "Okwenzeke Kutshanje",
    
    // CV Builder
    "cv.builder.title": "Umakhi we-CV",
    "cv.builder.save": "Gcina",
    "cv.builder.preview": "Jonga Kuqala",
    "cv.builder.download": "Dawunloda i-PDF",
    "cv.builder.step.personal": "Iinkcukacha Zakho",
    "cv.builder.step.summary": "Isishwankathelo",
    "cv.builder.step.experience": "Amava",
    "cv.builder.step.education": "Imfundo",
    "cv.builder.step.skills": "Izakhono",
    "cv.builder.step.references": "Izalathiso",
    
    // Personal Details
    "cv.personal.fullName": "Igama Elipheleleyo",
    "cv.personal.email": "Idilesi Ye-imeyile",
    "cv.personal.phone": "Inombolo Yefowuni",
    "cv.personal.city": "Isixeko",
    "cv.personal.province": "Iphondo",
    "cv.personal.nationality": "Ubuhlanga",
    "cv.personal.driversLicense": "Ilayisensi Yokuqhuba",
    "cv.personal.ownTransport": "Isithuthi Sakho",
    
    // Common Actions
    "common.save": "Gcina",
    "common.cancel": "Rhoxisa",
    "common.delete": "Cima",
    "common.edit": "Hlela",
    "common.add": "Yongeza",
    "common.remove": "Susa",
    "common.next": "Okulandelayo",
    "common.previous": "Okwangaphambili",
    "common.loading": "Iyalayisha...",
    "common.submit": "Ngenisa",
    "common.download": "Dawunloda",
    "common.share": "Yabelana",
    "common.preview": "Jonga Kuqala",
    
    // Auth
    "auth.login": "Ngena",
    "auth.register": "Bhalisa",
    "auth.email": "I-imeyile",
    "auth.password": "Iphaswedi",
    "auth.confirmPassword": "Qinisekisa Iphaswedi",
    "auth.fullName": "Igama Elipheleleyo",
    "auth.forgotPassword": "Ulibele Iphaswedi?",
    "auth.noAccount": "Akunayo iakhawunti?",
    "auth.hasAccount": "Sele unayo iakhawunti?",
    "auth.signUp": "Bhalisa",
    
    // Chatbot
    "chatbot.title": "Umncedisi we-Career Step",
    "chatbot.subtitle": "Uncedo Lwe-CV Nokukhangela Umsebenzi",
    "chatbot.placeholder": "Buza ngee-CV, udliwanondlebe, imisebenzi...",
    "chatbot.securityNote": "Ngokukhuseleka, amakhonkco avaliwe. Buza imibuzo enxulumene nomsebenzi kuphela.",
    "chatbot.welcome": "Molo! Ndingumncedisi we-Career Step. Ndinokukunceda nge:\n\n• Amacebiso okubhala i-CV\n• Ukulungiselela udliwanondlebe\n• Amacebiso okukhangela umsebenzi\n• Ukusebenzisa iimpawu ze-Career Step\n• Ulwazi lwemarike yomsebenzi yaseMzantsi Afrika\n\nNdingakunceda ngantoni namhlanje?",
    
    // WhatsApp Share
    "share.whatsapp": "Yabelana ku-WhatsApp",
    "share.whatsappMessage": "Jonga i-CV yam yobungcali eyenziwe nge-Career Step!",
    
    // Footer
    "footer.privacy": "Umgaqo-nkqubo Wabucala",
    "footer.terms": "Imiqathango Yenkonzo",
    "footer.cookies": "Umgaqo-nkqubo Weekhuki",
    "footer.copyright": "© 2025 Career Step. Onke amalungelo agciniwe.",
    
    // About Page
    "about.title": "Malunga ne-Career Step",
    "about.subtitle": "Sinceda abantu baseMzantsi Afrika ukwenza ii-CV zobungcali, ezinyani ezibanceda bafumane umsebenzi.",
    "about.back": "Emva",
    "about.mission.title": "Injongo Yethu",
    "about.mission.text": "I-Career Step ikhona ukunceda abafuna umsebenzi baseMzantsi Afrika ukuba bazibonise ngobungcali nangokwenyani. Siyakholelwa ukuba wonke umntu ufanelwe ukufikelela kwizixhobo ezazithe zafikeleleka kuphela kwabo banokukwazi ukuhlawula ababhali bee-CV abaduru okanye abacebisi bomsebenzi.",
    "about.problem.title": "Ingxaki Esiyisombululayo",
    "about.problem.intro": "Yonke imihla, abantu baseMzantsi Afrika abaneempawu baphoswa yimisebenzi kuba:",
    "about.problem.1": "Ii-CV zabo azidluli kwiinkqubo zokuhlola ezizenzekayo (ATS)",
    "about.problem.2": "Abazi ukuba bangayibonisa njani imava yabo ngobungcali",
    "about.problem.3": "Iinkonzo zee-CV zobungcali zibiza i-R500-R2000+ nge-CV",
    "about.problem.4": "Abazi ukuba bangalindela imali engakanani okanye bangazilungiselela njani iindliwano-ndlebe",
    "about.problem.solution": "I-Career Step isombulula konke oku nge-R25 kuphela iintsuku ezingama-30 — ngaphantsi kwesidlo esingaphakathi.",
    "about.values.title": "Oko Sikumeleyo",
    "about.values.honesty.title": "Ukunyaniseka Kuqala",
    "about.values.honesty.text": "Sikunceda ukubonisa amava akho okwenyani ngendlela elungileyo. Asisoze sikuncede ukuqamba iziqinisekiso okanye ukwenza amava. Abaqeshi bayakuxabisa ukunyaniseka, nathi sikuxabisa.",
    "about.values.affordable.title": "Ukufikelela Okutshiphu",
    "about.values.affordable.text": "Izixhobo zobungcali akufuneki zibe zezabo kuphela abanokukwazi ukuhlawula iinkonzo eziduru. Nge-R25 iintsuku ezingama-30, i-Career Step iyafikeleleka kuye wonke umntu onobuhlobo nokukhangela umsebenzi.",
    "about.values.local.title": "Yakhelwe i-SA",
    "about.values.local.text": "Siyayiqonda imarike yomsebenzi yaseMzantsi Afrika. Idatha yethu yemivuzo, ulwazi lwamalungelo asekusebenzeni, kunye neefomu zee-CV konke kwenzelwe abaqeshi bendawo kunye nemigangatho.",
    "about.features.title": "Oko Ukufumanayo",
    "about.features.1": "Umakhi we-CV wobungcali kunye namatempleti alungele i-ATS",
    "about.features.2": "Ukuya kwii-CV ezintandathu ezahlukeneyo zeentlobo ezahlukeneyo zemisebenzi",
    "about.features.3": "Umakhi wencwadi yokufaka isicelo olungiselelwe umsebenzi ngamnye",
    "about.features.4": "Umlandeli wezicelo zomsebenzi ukuhlala ucwangcisiwe",
    "about.features.5": "Idatha yemivuzo yase-SA ukuze wazi ukuba uxabiseke kangakanani",
    "about.features.6": "Izixhobo zokulungiselela udliwano-ndlebe",
    "about.features.7": "Uhlalutyo lwezakhono kunye neengcebiso zezifundo zasimahla",
    "about.features.8": "Ulwazi lwamalungelo asekusebenzeni",
    "about.features.9": "Amatempleti ee-imeyile okulandela",
    "about.features.10": "Ukucwangcisa indlela yomsebenzi",
    "about.stats.templates": "Amatempleti alungele i-ATS",
    "about.stats.profiles": "Iiprofayile Zomsebenzi zase-SA",
    "about.stats.provinces": "Amaphondo Ahlanganisiweyo",
    "about.cta.title": "Ulungile Ukuthatha Inyathelo Elilandelayo?",
    "about.cta.text": "Joyina amawaka abantu baseMzantsi Afrika abathatha ulawulo lokukhangela kwabo umsebenzi ngezixhobo zobungcali.",
    "about.cta.button": "Qala - R25 Iintsuku Ezingama-30",
    "about.cta.login": "Sele unayo iakhawunti? Ngena",
    "about.contact.title": "Imibuzo?",
    "about.contact.text": "Sithumelele i-imeyile ku",
    
    // Login Page
    "login.title": "Wamkelekile kwakhona",
    "login.subtitle": "Ngena ukuze uqhubeke nokwakha i-CV yakho",
    "login.email": "I-imeyile",
    "login.password": "Iphaswedi",
    "login.forgotPassword": "Ulibele iphaswedi?",
    "login.submit": "Ngena",
    "login.submitting": "Iyangenisa...",
    "login.noAccount": "Akunayo iakhawunti?",
    "login.signUp": "Bhalisa",
    "login.testimonial": "I-Career Step indincedile ukufumana umsebenzi wam wokuqala. I-AI yenze amava am amancinci avakale ngobungcali ngaphandle kokuqamba.",
    "login.testimonialAuthor": "— Thabo M., Cape Town",
    
    // Register Page
    "register.title": "Yenza Iakhawunti Yakho",
    "register.subtitle": "Qala ukwakha i-CV yakho yobungcali namhlanje",
    "register.fullName": "Igama Elipheleleyo",
    "register.fullNamePlaceholder": "Igama lakho elipheleleyo",
    "register.email": "I-imeyile",
    "register.emailPlaceholder": "wena@umzekelo.com",
    "register.password": "Iphaswedi",
    "register.passwordPlaceholder": "Yenza iphaswedi enamandla",
    "register.passwordReq.length": "Ubuncinane boonobumba abasibhozo",
    "register.passwordReq.upper": "Unobumba omnye omkhulu",
    "register.passwordReq.number": "Inombolo enye",
    "register.submit": "Yenza Iakhawunti",
    "register.submitting": "Iyenza Iakhawunti...",
    "register.hasAccount": "Sele unayo iakhawunti?",
    "register.login": "Ngena",
    "register.terms": "Ngokwenza iakhawunti, uyavumelana ne",
    "register.termsLink": "Imiqathango",
    "register.privacyLink": "Umgaqo-nkqubo Wabucala",
    "register.success.title": "Wamkelekile ku-Career Step!",
    "register.success.text": "Iakhawunti yakho yenziwe ngempumelelo. Sikuthumela ekungeneni...",
    "register.success.redirecting": "Iyathumela...",
    "register.success.button": "Yiya Ekungeneni Ngoku",
    "register.success.hint": "Ngoku ungangena uqale ukwenza i-CV yakho yobungcali!",
    
    // Landing Page Extended
    "landing.successStories.badge": "Iziphumo Zokwenene",
    "landing.successStories.title": "Bakwenzile. Nawe Ungakwenza.",
    "landing.successStories.subtitle": "AbaseMzantsi Afrika bokwenene abaguqule imisebenzi yabo nge-Career Step",
    "landing.successStories.before": "NGAPHAMBI",
    "landing.successStories.after": "EMVA",
    "landing.successStories.keyFeature": "Uphawu Olubalulekileyo:",
    "landing.successStories.cta": "Ulungile ukubhala ibali lakho lempumelelo?",
    "landing.successStories.button": "Qala nge-R25 Kuphela",
    "landing.motivation.text1": "Ungavumeli",
    "landing.motivation.text2": "ime phakathi kwakho nomsebenzi wakho olandelayo.",
    "landing.motivation.subtext": "Umsebenzi wakho uxabiseke ngaphezulu kunendebe yekofu. Tyala imali kuwe namhlanje.",
    "landing.features.title": "Yonke Into Oyidingayo Ukuze Uqashwe",
    "landing.features.subtitle": "Ukusuka ekwakheni i-CV ukuya ekulungiseleni udliwano-ndlebe, sikuxhasile.",
    "landing.features.ats.title": "Ii-CV Ezilungele i-ATS",
    "landing.features.ats.desc": "Yenza ii-CV zobungcali ezidlula kwiNkqubo Zokulandela Abafaki Zicelo ezisetyenziswa ngabaqashi base-SA.",
    "landing.features.match.title": "Ukufaniswa Komsebenzi",
    "landing.features.match.desc": "Fanisa i-CV yakho neenkcukacha zomsebenzi uze ufumane amanqaku okuhambisana ne-ATS anyanisekileyo.",
    "landing.features.interview.title": "Ukulungiselela Udliwano-ndlebe",
    "landing.features.interview.desc": "Imibuzo yodliwano-ndlebe eyenziwe yi-AI esekelwe kumava AKHO okwenene.",
    "landing.features.pdf.title": "Ukudawunloda i-PDF Ecocekileyo",
    "landing.features.pdf.desc": "Dawunloda ii-PDF zobungcali, ezifundeka yi-ATS. Akukho zimaki zamanzi, nangaliphi na ixesha.",
    "landing.ats.badge": "Amatempleti Avunyiweyo yi-ATS",
    "landing.ats.title": "I-CV Yakho Iza Kubonwa Ngokwenene",
    "landing.ats.subtitle": "90% yeenkampani zisebenzisa Iinkqubo Zokulandela Abafaki Zicelo (ATS) ukuhlungela ii-CV ngaphambi kokuba umntu azibone. Amatempleti ethu akhiwe ukudlula kwezi nkqubo.",
    "landing.ats.feature1.title": "Isakhiwo Sekholomu Enye Esicocekileyo",
    "landing.ats.feature1.desc": "Akukho matafule okanye amakholomu adidayo iinkqubo ze-ATS ezingenakuzifunda kakuhle",
    "landing.ats.feature2.title": "Iifonti Ezisemgangathweni Wobungcali",
    "landing.ats.feature2.desc": "I-Helvetica kunye nezinye iifonti yonke inkqubo eyibonakalisa ngokugqibeleleyo",
    "landing.ats.feature3.title": "Izihloko Zamasebe Ezicacileyo",
    "landing.ats.feature3.desc": "AMAVA, IMFUNDO, IZAKHONO - ibhalwe kanye njengoko i-ATS ilindele",
    "landing.ats.feature4.title": "Akukho Mbhalo Ufihlakeleyo Okanye Imifanekiso",
    "landing.ats.feature4.desc": "Lonke igama ngumbhalo ofundekayo, awufihlwanga kwimifanekiso okanye kwigrafikhi",
    "landing.ats.feature5.title": "Ilungiselelwe Amagama Aphambili",
    "landing.ats.feature5.desc": "I-AI yethu inceda ukufanisa i-CV yakho neenkcukacha zomsebenzi ukuze ubekwe ngcono",
    "landing.ats.feature6.title": "Ivavanyelwe & Iqinisekisiwe",
    "landing.ats.feature6.desc": "Onke amatempleti amathandathu avavanywe ngokuchasene neenkqubo ezinkulu ze-ATS ezisetyenziswa e-SA",
    "landing.ats.tip": "Ungachithi ixesha nge-CV eyalelwa ngokuzenzekelayo. Amatempleti ethu enzelwe ukukusa kudliwano-ndlebe.",
    "landing.cvTypes.title": "Itempleti le-CV Lesigaba Ngasinye",
    "landing.cvTypes.subtitle": "Nokuba uqala okanye utshintsha imisebenzi, sikuxhasile.",
    "landing.cvTypes.noExp.title": "Akukho Mava",
    "landing.cvTypes.noExp.desc": "Abafuna umsebenzi okokuqala, abaphuma esikolweni",
    "landing.cvTypes.entry.title": "Inqanaba Lokuqala",
    "landing.cvTypes.entry.desc": "Abanomatriki, abafundelwa, abaphumeleleyo",
    "landing.cvTypes.exp.title": "Onamava",
    "landing.cvTypes.exp.desc": "Abasebenzi abanomlando womsebenzi",
    "landing.cvTypes.switch.title": "Otshintsha Umsebenzi",
    "landing.cvTypes.switch.desc": "Utshintsha amashishini okanye izikhundla",
    "landing.translator.badge": "Isekelwa yi-AI",
    "landing.translator.title": "Guqula Amava Angekho Semthethweni Abe Ngamagama Obungcali",
    "landing.translator.subtitle": "Unamava omsebenzi angekho semthethweni? I-AI yethu iyawaguqulela kulwimi lwe-CV lobungcali—ngaphandle kokukhweza okanye ukuxoka.",
    "landing.translator.input": "Ubhala:",
    "landing.translator.inputExample": "Ndincedile evenkileni yosapho",
    "landing.translator.output": "I-AI ibhala kwakhona:",
    "landing.translator.outputExample": "Ndincede ngeenkonzo zabathengi, ukulawula izinto ezithengwayo, kunye nokusebenza kwemihla ngemihla kwindawo yokuthengisa yosapho.",
    "landing.translator.cta.title": "Qala Namhlanje",
    "landing.translator.cta.1": "Akufuneki ikhadi letyala ukuqala",
    "landing.translator.cta.2": "Rhoxisa nanini na, akukho zohlwayo",
    "landing.translator.cta.3": "Zonke iimpawu ukusuka ngosuku lokuqala",
    "landing.translator.cta.button": "Qala - R25",
    "landing.finalCta.title": "Umsebenzi Wakho Wephupha Uyalinda",
    "landing.finalCta.subtitle": "Ungavumeli i-R25 ibe sisizathu sokuba uphoswe lithuba lakho elilandelayo",
    "landing.finalCta.price": "R25",
    "landing.finalCta.period": "Iintsuku Ezingama-30 Zokufikelela Okupheleleyo",
    "landing.finalCta.note": "Idatha yakho ihlala ikhuselekile ngonaphakade • Hlawula kuphela xa ufuna",
    "landing.finalCta.feature1": "Ukuya kwii-CV ezintandathu zobungcali",
    "landing.finalCta.feature2": "Ukuphuculwa kwe-CV ngamandla e-AI",
    "landing.finalCta.feature3": "Umvavanyi Wokuziqhelanisa we-AI",
    "landing.finalCta.feature4": "Umakhi Wencwadi Yokufaka Isicelo",
    "landing.finalCta.feature5": "Ukufaniswa komsebenzi & amanqaku e-ATS",
    "landing.finalCta.feature6": "Ukudawunloda i-PDF okungenasiphelo",
    "landing.finalCta.feature7": "Izixhobo zemisebenzi zase-SA & izikhokelo",
    "landing.finalCta.button": "Tyala Imali Kwikamva Lakho - R25",
    "landing.finalCta.secure": "Intlawulo ekhuselekileyo • Rhoxisa nanini na • Akukho zindleko ezifihlakeleyo",
    "landing.footer.brand": "Career Step",
    "landing.footer.brandDesc": "Ukwakha i-CV yobungcali yabafuna umsebenzi baseMzantsi Afrika. Sikunceda ukubonisa amava akho okwenene ngobungcali.",
    "landing.footer.quickLinks": "Amakhonkco Akhawulezayo",
    "landing.footer.getStarted": "Qala",
    "landing.footer.login": "Ngena",
    "landing.footer.about": "Malunga Nathi",
    "landing.footer.legal": "Okusemthethweni",
    "landing.footer.connect": "Qhagamshela",
    "landing.footer.facebook": "Facebook",
    "landing.footer.copyright": "Yenziwe ngothando eMzantsi Afrika.",
    "landing.footer.promise": "Asenzi amava obuxoki. Ulwazi lwakho luhlala luyimfihlo.",
  },
  
  af: {
    // Header & Navigation
    "nav.about": "Oor Ons",
    "nav.login": "Teken In",
    "nav.getStarted": "Kry 30 Dae vir R25",
    "nav.dashboard": "Paneelbord",
    "nav.logout": "Teken Uit",
    
    // Landing Page
    "landing.badge": "Gebou vir Suid-Afrikaanse Werksoekers",
    "landing.title": "Kry Jou Droomwerk",
    "landing.titleHighlight": "met 'n Eerlike CV",
    "landing.subtitle": "Skep professionele, ATS-vriendelike CV's wat jou werklike ervaring vertoon. Geen vals kwalifikasies nie. Geen verdigte vaardighede nie. Net jy, professioneel aangebied.",
    "landing.cta": "Begin Bou Aan Jou CV",
    "landing.pricing.title": "30 Dae Volle Toegang",
    "landing.pricing.price": "R25",
    "landing.pricing.period": "eenmalig",
    "landing.pricing.features.cvs": "Tot 6 professionele CV's",
    "landing.pricing.features.ai": "KI-aangedrewe CV-verbetering",
    "landing.pricing.features.interview": "KI Skyn-onderhoud oefening",
    "landing.pricing.features.matching": "Werkpassing & ATS-telling",
    "landing.pricing.features.pdf": "Onbeperkte PDF-aflaaie",
    "landing.pricing.cta": "Begin Nou",
    "landing.pricing.note": "Geen outomatiese hernuwing nie • Jou data bly vir altyd veilig",
    "landing.promise": "Ons Belofte:",
    "landing.promiseText": "Ons maak nooit ervaring of kwalifikasies op nie. Jou CV bevat slegs wat jy verskaf.",
    
    // Dashboard
    "dashboard.welcome": "Welkom terug",
    "dashboard.myCvs": "My CV's",
    "dashboard.createCv": "Skep Nuwe CV",
    "dashboard.noCvs": "Jy het nog geen CV's geskep nie",
    "dashboard.noCvsSubtext": "Skep jou eerste professionele CV binne minute",
    "dashboard.stats.cvs": "CV's Geskep",
    "dashboard.stats.downloads": "Aflaaie",
    "dashboard.stats.atsScore": "Gem. ATS-telling",
    "dashboard.stats.applications": "Aansoeke",
    "dashboard.tools": "Loopbaangereedskap",
    "dashboard.tools.coverLetter": "Dekkingsbrief",
    "dashboard.tools.coverLetterDesc": "Skep aangepaste dekkingsbriewe",
    "dashboard.tools.interview": "Onderhoudvoorbereiding",
    "dashboard.tools.interviewDesc": "KI-aangedrewe skynonderhoude",
    "dashboard.tools.mockInterview": "Skyn-onderhoud",
    "dashboard.tools.mockInterviewDesc": "Oefen met KI-onderhoudvoerder",
    "dashboard.tools.jobMatch": "Werkpasser",
    "dashboard.tools.jobMatchDesc": "Pas CV by werksbeskrywings",
    "dashboard.tools.salaryGuide": "SA Salarisgids",
    "dashboard.tools.salaryGuideDesc": "Ken jou waarde",
    "dashboard.tools.skills": "Vaardigheidsgaping",
    "dashboard.tools.skillsDesc": "Vind kursusse om te verbeter",
    "dashboard.tools.tracker": "Aansoekopsporder",
    "dashboard.tools.trackerDesc": "Volg jou werkaansoeke",
    "dashboard.tools.resources": "SA Hulpbronne",
    "dashboard.tools.resourcesDesc": "Werkplek-regte & gidse",
    "dashboard.subscription.active": "Intekening Aktief",
    "dashboard.subscription.expires": "Verval",
    "dashboard.subscription.renew": "Hernu Intekening",
    "dashboard.subscription.subscribe": "Teken In",
    "dashboard.subscription.locked": "Kenmerk Gesluit",
    "dashboard.subscription.unlockMsg": "Teken in vir R25 vir 30 dae om alle kenmerke te ontsluit",
    "dashboard.cv.edit": "Wysig",
    "dashboard.cv.preview": "Voorskou",
    "dashboard.cv.download": "Laai Af",
    "dashboard.cv.delete": "Verwyder",
    "dashboard.cv.share": "Deel",
    "dashboard.cv.lastUpdated": "Laas opgedateer",
    "dashboard.cv.atsScore": "ATS-telling",
    "dashboard.sidebar.dashboard": "Paneelbord",
    "dashboard.sidebar.cvBuilder": "CV-bouer",
    "dashboard.sidebar.coverLetter": "Dekkingsbrief",
    "dashboard.sidebar.interview": "Onderhoudvoorbereiding",
    "dashboard.sidebar.jobTracker": "Werkopsporder",
    "dashboard.sidebar.salaryGuide": "Salarisgids",
    "dashboard.sidebar.settings": "Instellings",
    "dashboard.sidebar.logout": "Teken Uit",
    "dashboard.sidebar.admin": "Adminpaneel",
    "dashboard.quickActions": "Vinnige Aksies",
    "dashboard.recentActivity": "Onlangse Aktiwiteit",
    
    // CV Builder
    "cv.builder.title": "CV-bouer",
    "cv.builder.save": "Stoor",
    "cv.builder.preview": "Voorskou",
    "cv.builder.download": "Laai PDF Af",
    "cv.builder.step.personal": "Persoonlike Besonderhede",
    "cv.builder.step.summary": "Opsomming",
    "cv.builder.step.experience": "Ervaring",
    "cv.builder.step.education": "Opvoeding",
    "cv.builder.step.skills": "Vaardighede",
    "cv.builder.step.references": "Verwysings",
    
    // Personal Details
    "cv.personal.fullName": "Volle Naam",
    "cv.personal.email": "E-posadres",
    "cv.personal.phone": "Telefoonnommer",
    "cv.personal.city": "Stad",
    "cv.personal.province": "Provinsie",
    "cv.personal.nationality": "Nasionaliteit",
    "cv.personal.driversLicense": "Bestuurslisensie",
    "cv.personal.ownTransport": "Eie Vervoer",
    
    // Common Actions
    "common.save": "Stoor",
    "common.cancel": "Kanselleer",
    "common.delete": "Skrap",
    "common.edit": "Wysig",
    "common.add": "Voeg By",
    "common.remove": "Verwyder",
    "common.next": "Volgende",
    "common.previous": "Vorige",
    "common.loading": "Laai...",
    "common.submit": "Dien In",
    "common.download": "Laai Af",
    "common.share": "Deel",
    "common.preview": "Voorskou",
    
    // Auth
    "auth.login": "Teken In",
    "auth.register": "Registreer",
    "auth.email": "E-pos",
    "auth.password": "Wagwoord",
    "auth.confirmPassword": "Bevestig Wagwoord",
    "auth.fullName": "Volle Naam",
    "auth.forgotPassword": "Wagwoord Vergeet?",
    "auth.noAccount": "Het jy nie 'n rekening nie?",
    "auth.hasAccount": "Het jy reeds 'n rekening?",
    "auth.signUp": "Teken Aan",
    
    // Chatbot
    "chatbot.title": "Career Step Assistent",
    "chatbot.subtitle": "CV & Werksoek Hulp",
    "chatbot.placeholder": "Vra oor CV's, onderhoude, werk...",
    "chatbot.securityNote": "Vir sekuriteit word skakels geblokkeer. Vra slegs werkverwante vrae.",
    "chatbot.welcome": "Hallo! Ek is die Career Step assistent. Ek kan jou help met:\n\n• CV-skryf wenke\n• Onderhoudvoorbereiding\n• Werksoek advies\n• Gebruik van Career Step funksies\n• Suid-Afrikaanse arbeidsmark inligting\n\nHoe kan ek jou vandag help?",
    
    // WhatsApp Share
    "share.whatsapp": "Deel op WhatsApp",
    "share.whatsappMessage": "Kyk na my professionele CV geskep met Career Step!",
    
    // Footer
    "footer.privacy": "Privaatheidsbeleid",
    "footer.terms": "Diensvoorwaardes",
    "footer.cookies": "Koekie-beleid",
    "footer.copyright": "© 2025 Career Step. Alle regte voorbehou.",
    
    // About Page
    "about.title": "Oor Career Step",
    "about.subtitle": "Ons help Suid-Afrikaners om professionele, eerlike CV's te skep wat werk kry.",
    "about.back": "Terug",
    "about.mission.title": "Ons Missie",
    "about.mission.text": "Career Step bestaan om werksoekers in Suid-Afrika te help om hulself professioneel en eerlik voor te stel. Ons glo elkeen verdien toegang tot gereedskap wat eens net beskikbaar was vir dié wat duur CV-skrywers of loopbaanafrigters kon bekostig.",
    "about.problem.title": "Die Probleem Wat Ons Oplos",
    "about.problem.intro": "Elke dag mis gekwalifiseerde Suid-Afrikaners werk omdat:",
    "about.problem.1": "Hulle CV's nie deur outomatiese siftingstelsels (ATS) kom nie",
    "about.problem.2": "Hulle nie weet hoe om hul ervaring professioneel aan te bied nie",
    "about.problem.3": "Professionele CV-dienste R500-R2000+ per CV vra",
    "about.problem.4": "Hulle nie weet watter salaris om te verwag of hoe om vir onderhoude voor te berei nie",
    "about.problem.solution": "Career Step los al hierdie probleme op vir net R25 vir 30 dae — minder as 'n wegneem-ete.",
    "about.values.title": "Waarvoor Ons Staan",
    "about.values.honesty.title": "Eerlikheid Eerste",
    "about.values.honesty.text": "Ons help jou om jou werklike ervaring in die beste lig te stel. Ons sal nooit help om kwalifikasies te versin of ervaring uit te dink nie. Werkgewers waardeer eerlikheid, en ons ook.",
    "about.values.affordable.title": "Bekostigbare Toegang",
    "about.values.affordable.text": "Professionele gereedskap hoef nie net vir dié te wees wat duur dienste kan bekostig nie. Teen R25 vir 30 dae is Career Step toeganklik vir almal wat ernstig is oor hul werksoektog.",
    "about.values.local.title": "Gebou vir SA",
    "about.values.local.text": "Ons verstaan die Suid-Afrikaanse arbeidsmark. Ons salarisdata, werkplekregtedata en CV-formate is almal aangepas vir plaaslike werkgewers en standaarde.",
    "about.features.title": "Wat Jy Kry",
    "about.features.1": "Professionele CV-bouer met ATS-vriendelike sjablone",
    "about.features.2": "Tot 6 verskillende CV's vir verskillende werkstipes",
    "about.features.3": "Dekkingsbrief-opsteller aangepas vir elke werk",
    "about.features.4": "Werkaansoek-opsporder om georganiseerd te bly",
    "about.features.5": "SA salarisdata sodat jy weet wat jy werd is",
    "about.features.6": "Onderhoudvoorbereidingsgereedskap",
    "about.features.7": "Vaardigheid-gaping-analise met gratis kursusaanbevelings",
    "about.features.8": "Werkplekregtedata",
    "about.features.9": "E-possjablone vir opvolgings",
    "about.features.10": "Loopbaanpadbeplan-ning",
    "about.stats.templates": "ATS-Vriendelike Sjablone",
    "about.stats.profiles": "SA Werksprofiele",
    "about.stats.provinces": "Provinsies Gedek",
    "about.cta.title": "Gereed Vir die Volgende Stap?",
    "about.cta.text": "Sluit aan by duisende Suid-Afrikaners wat beheer neem oor hul werksoektog met professionele gereedskap.",
    "about.cta.button": "Begin - R25 vir 30 Dae",
    "about.cta.login": "Het jy reeds 'n rekening? Teken in",
    "about.contact.title": "Vrae?",
    "about.contact.text": "Stuur vir ons 'n e-pos by",
    
    // Login Page
    "login.title": "Welkom terug",
    "login.subtitle": "Teken in om voort te gaan met jou CV",
    "login.email": "E-pos",
    "login.password": "Wagwoord",
    "login.forgotPassword": "Wagwoord vergeet?",
    "login.submit": "Teken In",
    "login.submitting": "Teken tans in...",
    "login.noAccount": "Het jy nie 'n rekening nie?",
    "login.signUp": "Registreer",
    "login.testimonial": "Career Step het my gehelp om my eerste werk te kry. Die KI het my beperkte ervaring professioneel laat klink sonder om te lieg.",
    "login.testimonialAuthor": "— Thabo M., Kaapstad",
    
    // Register Page
    "register.title": "Skep Jou Rekening",
    "register.subtitle": "Begin vandag om jou professionele CV te bou",
    "register.fullName": "Volle Naam",
    "register.fullNamePlaceholder": "Jou volle naam",
    "register.email": "E-pos",
    "register.emailPlaceholder": "jy@voorbeeld.com",
    "register.password": "Wagwoord",
    "register.passwordPlaceholder": "Skep 'n sterk wagwoord",
    "register.passwordReq.length": "Ten minste 8 karakters",
    "register.passwordReq.upper": "Een hoofletter",
    "register.passwordReq.number": "Een nommer",
    "register.submit": "Skep Rekening",
    "register.submitting": "Skep tans Rekening...",
    "register.hasAccount": "Het jy reeds 'n rekening?",
    "register.login": "Teken In",
    "register.terms": "Deur 'n rekening te skep, stem jy in tot ons",
    "register.termsLink": "Voorwaardes",
    "register.privacyLink": "Privaatheidsbeleid",
    "register.success.title": "Welkom by Career Step!",
    "register.success.text": "Jou rekening is suksesvol geskep. Ons herlei jou na aanmelding...",
    "register.success.redirecting": "Herlei tans...",
    "register.success.button": "Gaan Nou Na Aanmelding",
    "register.success.hint": "Jy kan nou aanmeld en begin om jou professionele CV te skep!",
    
    // Landing Page Extended
    "landing.successStories.badge": "Werklike Resultate",
    "landing.successStories.title": "Hulle Het Dit Gedoen. Jy Kan Ook.",
    "landing.successStories.subtitle": "Werklike Suid-Afrikaners wat hul loopbane verander het met Career Step",
    "landing.successStories.before": "VOOR",
    "landing.successStories.after": "NA",
    "landing.successStories.keyFeature": "Sleutelkenmerk:",
    "landing.successStories.cta": "Gereed om jou suksesverhaal te skryf?",
    "landing.successStories.button": "Begin Vir Net R25",
    "landing.motivation.text1": "Moenie",
    "landing.motivation.text2": "tussen jou en jou volgende werk laat staan nie.",
    "landing.motivation.subtext": "Jou loopbaan is meer werd as 'n koppie koffie. Belê vandag in jouself.",
    "landing.features.title": "Alles Wat Jy Nodig Het Om Aangestel Te Word",
    "landing.features.subtitle": "Van CV-skepping tot onderhoudvoorbereiding, ons het jou gedek.",
    "landing.features.ats.title": "ATS-Vriendelike CV's",
    "landing.features.ats.desc": "Skep professionele CV's wat deur Aansoeker-opspoorstelsels gebruik word deur SA-werkgewers kom.",
    "landing.features.match.title": "Werkpassing",
    "landing.features.match.desc": "Pas jou CV teen werkbeskrywings en kry eerlike ATS-versoenbaarheidtellings.",
    "landing.features.interview.title": "Onderhoudvoorbereiding",
    "landing.features.interview.desc": "KI-gegenereerde onderhoudvrae gebaseer op JOU werklike ervaring.",
    "landing.features.pdf.title": "Skoon PDF-aflaai",
    "landing.features.pdf.desc": "Laai professionele, ATS-leesbare PDF's af. Geen watermerke, ooit.",
    "landing.ats.badge": "ATS-Goedgekeurde Sjablone",
    "landing.ats.title": "Jou CV Sal Werklik Gesien Word",
    "landing.ats.subtitle": "90% van maatskappye gebruik Aansoeker-opspoorstelsels (ATS) om CV's te sif voor 'n mens dit ooit sien. Ons sjablone is gebou om deur hierdie stelsels te kom.",
    "landing.ats.feature1.title": "Skoon Enkelkolom-uitleg",
    "landing.ats.feature1.desc": "Geen verwarrende tabelle of kolomme wat ATS-stelsels nie reg kan lees nie",
    "landing.ats.feature2.title": "Standaard Professionele Lettertipes",
    "landing.ats.feature2.desc": "Helvetica en ander lettertipes wat elke stelsel perfek herken",
    "landing.ats.feature3.title": "Duidelike Afdelingsopskrifte",
    "landing.ats.feature3.desc": "ERVARING, OPLEIDING, VAARDIGHEDE - gemerk presies soos ATS verwag",
    "landing.ats.feature4.title": "Geen Verborge Teks of Grafika",
    "landing.ats.feature4.desc": "Elke woord is leesbare teks, nie begrawe in beelde of grafika nie",
    "landing.ats.feature5.title": "Sleutelwoord-geoptimaliseer",
    "landing.ats.feature5.desc": "Ons KI help om jou CV by werkbeskrywings te pas vir beter rangorde",
    "landing.ats.feature6.title": "Getoets & Geverifieer",
    "landing.ats.feature6.desc": "Al 6 sjablone getoets teen groot ATS-stelsels wat in SA gebruik word",
    "landing.ats.tip": "Moenie tyd mors op 'n CV wat outomaties verwerp word nie. Ons sjablone is ontwerp om jou na die onderhoud te kry.",
    "landing.cvTypes.title": "'n CV-Sjabloon Vir Elke Stadium",
    "landing.cvTypes.subtitle": "Of jy begin of loopbaan verander, ons het jou gedek.",
    "landing.cvTypes.noExp.title": "Geen Ervaring",
    "landing.cvTypes.noExp.desc": "Eerstekeer werksoekers, skoolverlaters",
    "landing.cvTypes.entry.title": "Intreevlak",
    "landing.cvTypes.entry.desc": "Matrikulante, interns, gegradueerdes",
    "landing.cvTypes.exp.title": "Ervare",
    "landing.cvTypes.exp.desc": "Werkers met werksgeskiedenis",
    "landing.cvTypes.switch.title": "Loopbaanwisselaar",
    "landing.cvTypes.switch.desc": "Verander bedrywe of rolle",
    "landing.translator.badge": "KI-Aangedryf",
    "landing.translator.title": "Verander Informele Ervaring In Professionele Woorde",
    "landing.translator.subtitle": "Het jy informele werkservaring? Ons KI vertaal dit in professionele CV-taal—sonder om te oordryf of te lieg.",
    "landing.translator.input": "Jy tik:",
    "landing.translator.inputExample": "Gehelp by familiewinkel",
    "landing.translator.output": "KI herskryf:",
    "landing.translator.outputExample": "Bygestaan met kliëntediens, voorraadhantering, en daaglikse bedrywighede in 'n familiebesture kleinhandelomgewing.",
    "landing.translator.cta.title": "Begin Vandag",
    "landing.translator.cta.1": "Geen kredietkaart nodig om te begin",
    "landing.translator.cta.2": "Kanselleer enige tyd, geen strawwe",
    "landing.translator.cta.3": "Volle kenmerke van dag een",
    "landing.translator.cta.button": "Begin - R25",
    "landing.finalCta.title": "Jou Droomwerk Wag",
    "landing.finalCta.subtitle": "Moenie R25 die rede laat wees hoekom jy jou volgende geleentheid misloop nie",
    "landing.finalCta.price": "R25",
    "landing.finalCta.period": "30 Dae Volle Toegang",
    "landing.finalCta.note": "Jou data bly vir altyd veilig • Betaal net wanneer jy nodig het",
    "landing.finalCta.feature1": "Tot 6 professionele CV's",
    "landing.finalCta.feature2": "KI-aangedrewe CV-verbetering",
    "landing.finalCta.feature3": "KI Skyn-onderhoudvoerder",
    "landing.finalCta.feature4": "Dekkingsbrief-bouer",
    "landing.finalCta.feature5": "Werkpassing & ATS-telling",
    "landing.finalCta.feature6": "Onbeperkte PDF-aflaaie",
    "landing.finalCta.feature7": "SA Werkshulpbronne & gidse",
    "landing.finalCta.button": "Belê In Jou Toekoms - R25",
    "landing.finalCta.secure": "Veilige betaling • Kanselleer enige tyd • Geen verborge fooie",
    "landing.footer.brand": "Career Step",
    "landing.footer.brandDesc": "Professionele CV-skepping vir Suid-Afrikaanse werksoekers. Ons help jou om jou werklike ervaring professioneel voor te stel.",
    "landing.footer.quickLinks": "Vinnige Skakels",
    "landing.footer.getStarted": "Begin",
    "landing.footer.login": "Teken In",
    "landing.footer.about": "Oor Ons",
    "landing.footer.legal": "Regsake",
    "landing.footer.connect": "Kontak",
    "landing.footer.facebook": "Facebook",
    "landing.footer.copyright": "Gemaak met sorg in Suid-Afrika.",
    "landing.footer.promise": "Ons skep nie vals ervaring nie. Jou inligting bly privaat.",
  }
};

export const languages = [
  { code: 'en', name: 'English', flag: '🇬🇧' },
  { code: 'zu', name: 'isiZulu', flag: '🇿🇦' },
  { code: 'xh', name: 'isiXhosa', flag: '🇿🇦' },
  { code: 'af', name: 'Afrikaans', flag: '🇿🇦' },
];

export default translations;
